var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._b({},'div',_vm.wrapperProps,false),[_c('p',_vm._b({directives:[{name:"sanitized-html",rawName:"v-sanitized-html",value:(_vm.replaceServiceSequenceVariables(_vm.text, _vm.reactive.serviceSequenceLiveData)),expression:"replaceServiceSequenceVariables(text, reactive.serviceSequenceLiveData)"}]},'p',_vm.textProps,false))])
}
var staticRenderFns = []

export { render, staticRenderFns }